import React from "react";
import PropTypes from "prop-types";
import VidInterviewerLogo from "../../../assets/images/VidInterviewerLogo.png";

const Footer = ({ setShowContactForm = () => {} }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-ashGray text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 font-sans">
          {/* Company Info */}
          <div className="flex flex-col items-start">
            <div className="flex items-center mb-3">
              <img
                src={VidInterviewerLogo}
                alt="VidInterviewer Logo"
                className="w-12 h-12 object-contain mr-2"
              />
              <h3 className="text-xl font-bold bg-clip-text text-transparent bg-gradient-primary">
                VidInterviewer
              </h3>
            </div>
            <p className="text-white/70 mb-4 max-w-xs">
              Revolutionizing the hiring process with DIY video interviews.
            </p>
          </div>

          {/* Navigation Links */}
          <div className="flex flex-col">
            <h3 className="text-lg font-semibold mb-4">Navigation</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="text-white/70 hover:text-peachYellow transition-colors duration-300"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowContactForm(true);
                  }}
                  className="text-white/70 hover:text-peachYellow transition-colors duration-300"
                >
                  Get Started
                </button>
              </li>
              <li>
                <a
                  href="#our-process"
                  className="text-white/70 hover:text-peachYellow transition-colors duration-300"
                >
                  Our Process
                </a>
              </li>
              <li>
                <a
                  href="#features"
                  className="text-white/70 hover:text-peachYellow transition-colors duration-300"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="#pricing"
                  className="text-white/70 hover:text-peachYellow transition-colors duration-300"
                >
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="flex flex-col">
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <svg
                  className="w-5 h-5 text-peachYellow/80 mr-3 flex-shrink-0 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <span className="text-white/70 hover:text-white transition-colors duration-300">
                  vidinterviewer@gmail.com
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  className="w-5 h-5 text-peachYellow/80 mr-3 flex-shrink-0 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <span className="text-white/70">
                  Washington, DC 20001
                  <br />
                  United States
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-roseBrown/30 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/60 text-sm">
            © {currentYear} VidInterviewer. All rights reserved.
          </p>
          {/* <div className="mt-4 md:mt-0">
            <ul className="flex space-x-6">
              <li>
                <a
                  href="#"
                  className="text-white/70 hover:text-peachYellow text-sm transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-white/70 hover:text-peachYellow text-sm transition-colors"
                >
                  Terms of Service
                </a>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  setShowContactForm: PropTypes.func,
};

export default Footer;
